import {DayBar} from "./DayBar";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../../columns";
import {DatetimeHelper} from "../../../../../../utils/DatetimeHelper";

export class BudgetDayBar extends DayBar {
    baseCssClasses() {
        const base = `graphic-item`;
        if (this.props.isToday) {
            const fluctuationClass = `-${this.props.fluctuation}`;
            return `${base} -spotlight ${fluctuationClass}`;
        } else {
            return base;
        }
    }

    renderTitle() {
        const expectingText = this.props.expectedSpentOnDay !== null ? ` Se esperaba gastar ${this.props.expectedSpentOnDay}.` : "";
        const basicTitle = `Día ${this.props.dayNumber}: Gastaste ${this.props.spentOnDay}.${expectingText}\n`;
        if (this.props.rollover) {
            const lastPeriodBalance = this.props.balance;
            const allocatedBudget = this.props.allocatedBudget;

            const rolloverTooltip = `Rollover está habilitado.\nEl balance del último período ${lastPeriodBalance}.\nEl presupuesto asignado actualmente es de ${allocatedBudget}.`;
            return basicTitle + rolloverTooltip  // Aca no dice nada de Presupuestos por Tramos.
        } else {
            // Si tiene presupuesto por tramos
            if(this.props.budgetPartialGoalAllocatedBudget !== undefined && this.props.budgetPartialGoalAllocatedBudget !== null) {
                const budgetPartialGoalText = `\nPresupuesto por tramos: Invertir ${this.props.budgetPartialGoalAllocatedBudget} para el ${DatetimeHelper.YYYYMMDDToFriendlyStr(this.props.budgetPartialGoalDate)}.`;
                return basicTitle + budgetPartialGoalText;

            } else {
                return basicTitle
            }
        }
    }

    renderCellContent() {
        if(!this.props.isToday)
            return "";

        if(this.props.fluctuationPercentage !== COLUMN_CELL_INVALID_CONTENT)
            return this.props.fluctuationPercentage
        else
            return this.props.spentOnDay;
    }
}
